import { connect } from 'react-redux';
import { channelLayoutValues } from 'default-settings';
import ui from 'redux-ui';

import { videosPerPage } from 'widget/utils/videos-sizes';
import BIUnhandledErrorLogger from 'shared/bi/bi-unhandled-error-logger';

import SEARCH_QUERY_FIELDS from 'shared/constants/search-query-fields';
import { COMPACT_NUMBER_OF_ROWS, COMPACT_VIDEOS_IN_ROW } from 'shared/constants/compact-layout';

import { getChannelForWidget } from 'shared/selectors/channels';
import { getAllSettings, getNumberOfRows } from 'shared/selectors/app-settings';
import getVideoIdFromUrl from 'widget/selectors/video-id-from-url';
import { getMainVideoId } from 'widget/ui-selectors/selected-video-id';
import { selectVideo } from 'widget/redux/client/actions/select-video';

import TooltipPopout from 'shared/components/tooltip/tooltip-popout';
import Modal from 'shared/components/modal/modal';

import ExperimentsLoader from 'shared/data-components/experiments';
import AppSettingsLoader from 'widget/data-components/app-settings';
import UpdateChannelPublishedState from 'widget/data-components/update-channel-published-state';
import ChannelLoader from 'widget/data-components/channel';
import PaymentInfoLoader from 'widget/data-components/payment-info';
import ChannelVideoLoader from 'widget/data-components/channel-video';
import PaginatedChannelVideosLoader, { DATA_KEY as PAGINATED_VIDEOS_KEY } from 'widget/data-components/paginated-channel-videos';
import NextChannelVideosLoader from 'widget/data-components/next-channel-videos';
import CurrentSiteUser from 'widget/data-components/current-site-user';
import ReloadChannelPaymentDataOnPayment from 'widget/data-components/reload-channel-payment-data-on-payment';
import ClearVideoUrlsCacheOnPayment from 'widget/data-components/clear-video-urls-cache-on-payment';
import PaymentEventProxy from 'shared/components/payment-events/proxy';


import 'shared/styles/core.styl';


@connect(state => ({
  appSettings: getAllSettings(state),
  selectedVideoId: state.selectedVideoId,
  channelData: getChannelForWidget(state),
  currentChannelId: state.currentChannelId,
  mainVideoId: getMainVideoId(state, PAGINATED_VIDEOS_KEY),
  numberOfRows: getNumberOfRows(state),
  videoIdFromUrl: getVideoIdFromUrl(state),
}),
  {
    selectVideo,
  }
)
@ui({
  state: {
    searchQuery: '',
    searchQueryField: SEARCH_QUERY_FIELDS.QUERY,
  },
})
export default class DesktopLayout extends React.Component {

  static propTypes = {
    selectedVideoId: React.PropTypes.string,
    children: React.PropTypes.element,
    currentChannelId: React.PropTypes.string,
    mainVideoId: React.PropTypes.string,
    videoIdFromUrl: React.PropTypes.string,
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    selectVideo: React.PropTypes.func,
    ui: React.PropTypes.object,
    numberOfRows: React.PropTypes.number,
  };

  componentWillUpdate(nextProps) {
    const { videoIdFromUrl } = nextProps;
    if (videoIdFromUrl) {
      this.props.selectVideo(videoIdFromUrl);
    }
  }

  // Todo: move to loader or reducer
  get videosPerPage() {
    const { appSettings, numberOfRows, channelData } = this.props;
    const { videosInRow, channelLayout } = appSettings.numbers;
    const isStrip = channelLayout === channelLayoutValues.STRIP;
    const isCompact = channelLayout === channelLayoutValues.COMPACT;

    if (isCompact) {
      return COMPACT_NUMBER_OF_ROWS * COMPACT_VIDEOS_IN_ROW;
    }

    if (isStrip) {
      return videosInRow * numberOfRows;
    }

    const allVideosCount = channelData && channelData.videosCount;

    return videosPerPage(
      appSettings.requestedWidgetSize,
      videosInRow,
      allVideosCount,
      appSettings,
      channelData || {},
    );
  }

  get content() {
    const {
      children, appSettings, mainVideoId, videoIdFromUrl, currentChannelId, selectedVideoId,
      ui: { searchQuery, searchQueryField },
    } = this.props;

    if (!appSettings || !currentChannelId) {
      return null;
    }

    const nextChannelVideosVideoId = selectedVideoId || videoIdFromUrl || mainVideoId;

    return (
      <ChannelLoader channelId={currentChannelId}>
        <PaginatedChannelVideosLoader channelId={currentChannelId}
                                      videosPerUIPage={this.videosPerPage}
                                      searchQuery={searchQuery}
                                      searchQueryField={searchQueryField}
                                      as={PAGINATED_VIDEOS_KEY}>
          <ChannelVideoLoader channelId={currentChannelId}
                              videoId={videoIdFromUrl}>
            <NextChannelVideosLoader channelId={currentChannelId}
                                     currentVideoId={nextChannelVideosVideoId}>
              <CurrentSiteUser>
                <PaymentInfoLoader channelId={currentChannelId}>
                  {children}
                  <PaymentEventProxy />
                  <ReloadChannelPaymentDataOnPayment />
                  <ClearVideoUrlsCacheOnPayment />
                </PaymentInfoLoader>
              </CurrentSiteUser>
            </NextChannelVideosLoader>
          </ChannelVideoLoader>
        </PaginatedChannelVideosLoader>
      </ChannelLoader>
    );
  }

  render() {
    const { currentChannelId, appSettings } = this.props;

    return (
      <div>
        <ExperimentsLoader>
          <BIUnhandledErrorLogger />
          <AppSettingsLoader />
          <UpdateChannelPublishedState channelId={currentChannelId} />
          {this.content}

          <Modal settings={appSettings} />
          <TooltipPopout />
        </ExperimentsLoader>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/layouts/desktop/desktop.js